import React from 'react';

import { Trans, t } from '@lingui/macro';

import useI18n from '@zego/i18n/useI18n';
import {
  BREAKPOINTS,
  disabledColor,
  primaryColor,
  unit,
  white,
} from '@zego/theme';

import H2 from '@zego/components/atoms/H2';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import BoldText from '@zego/components/BoldText';
import ContentContainer from '@zego/components/ContentContainer';
import GooglePlayButton from '@zego/components/GooglePlayButton';
import ItunesButton from '@zego/components/ItunesButton';
import SectionDisplay from '@zego/components/SectionDisplay';
import StaticImage from '@zego/components/StaticImage';

import PhoneImage from '@zego/static/images/Phone.png';

import Backdrop from './Backdrop.svg';

const DownloadApp = ({ showBackground = true }) => {
  const { i18n } = useI18n();

  return (
    <div
      css={[
        showBackground
          ? {
              backgroundColor: disabledColor(2),
              [BREAKPOINTS.medium]: {
                backgroundColor: white,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '150%',
                backgroundImage: `url(${Backdrop})`,
                backgroundPositionX: '-30px',
                backgroundPositionY: '0px',
              },
              [BREAKPOINTS.large]: {
                backgroundSize: '100%',
                backgroundPositionX: '10px',
                backgroundPositionY: '0px',
              },
            }
          : null,
      ]}
      id="download-app"
    >
      <SectionDisplay>
        <ContentContainer
          css={{
            [BREAKPOINTS.medium]: {
              display: 'flex',
              flexDirection: 'row',
            },
          }}
        >
          <div
            css={{
              [BREAKPOINTS.medium]: {
                paddingRight: unit(4),
              },
            }}
          >
            <H2
              css={{
                color: primaryColor(11),
                fontSize: 62,
                lineHeight: '68px',
              }}
            >
              <Trans id="Download App Block / Title">Let’s get started</Trans>
            </H2>
            <Spacer height={unit(5)} />
            <BoldText
              css={{
                color: disabledColor(10),
                fontSize: 18,
              }}
            >
              <Trans id="Download App Block / Body">
                Download the Zego app to get your quote.
              </Trans>
            </BoldText>
            <Spacer height={unit(9)} />
            <div css={{ margin: -unit(1) }}>
              <View
                css={{
                  padding: unit(1),
                  [BREAKPOINTS.medium]: {
                    display: 'inline',
                  },
                }}
              >
                <ItunesButton darkTheme={true} />
              </View>
              <View
                css={{
                  padding: unit(1),
                  [BREAKPOINTS.medium]: {
                    display: 'inline',
                  },
                }}
              >
                <GooglePlayButton darkTheme={true} />
              </View>
            </div>
          </div>
          <div
            css={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              paddingTop: unit(4),
              [BREAKPOINTS.medium]: {
                paddingTop: 0,
              },
            }}
          >
            <div
              css={{
                width: '100%',
                maxWidth: 370,
              }}
            >
              <StaticImage
                alt={i18n._(
                  t(
                    'Download App Page / Phone image description',
                  )`A phone running the Zego app`,
                )}
                css={{
                  width: '100%',
                  display: 'block',
                }}
                src={PhoneImage}
                ratio={0.5}
              />
            </div>
          </div>
        </ContentContainer>
      </SectionDisplay>
    </div>
  );
};

export default DownloadApp;
